import { createFileRoute } from '@tanstack/react-router'
import { EmailTemplatesPage } from '@/features/admin/email-templates'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/email-templates/')({
  component: EmailTemplatesPage,
  beforeLoad: requireRole(['admin']),
})
